export default {
  text: '#343332',
  primary: '#202020',
  secondary: '#e0a964',
  background: 'white',
  backgroundSecondary: '#e3e3db',
  light: '#fdfdfd',
  dark: '#202020'
}
